export class UserContextModel {
    userId?: string;
    softwareId?: string;
    accountId?: string;
    tokenVersion?: number;
    softwareCode?: string;
    isSuperUser?: boolean;
    apiGatewayUrl?: string;
    lUserId?: number;
    lCompanyId?: number;
    iat?: number;
    exp?: number;
}

export class UserInfoModel {
    user?: Array<User>;
    account?: Account;
    property?: Property;
}

export interface User {
    ID?: string;
    email?: string;
    name?: string;
    department?: string;
}

export interface Account {
    ID?: string;
    name?: string;
    settings?: AccountSetting;
}

export interface AccountSetting {
    currencyCode: string;
    currencySymbol: string;
    isPaymentEnabled: boolean;
}

export interface Property {
    propertyId?: number;
    name?: string;
    measureUnitType?: string;
}
